import React from 'react'
import { useLocation } from 'react-router-dom'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const RepresentativeError: React.FC = () => {
  const query = useQuery()
  const orderId = query.get('order_id')
  const reason = query.get('reason')
  return (
    <div style={{ padding: 24 }}>
      <h2>Pagamento não concluído</h2>
      <p>Pedido: {orderId}</p>
      <p>Motivo: {reason ?? 'canceled'}</p>
      <p>Você pode tentar novamente ou voltar ao pedido.</p>
    </div>
  )
}

export default RepresentativeError

